import { isNullOrUndefined } from 'util';

export const capitalize = (value: string) => {
  return (value) ? value.charAt(0).toUpperCase() + value.slice(1) : value;
};

const reduceCapitalized = (acc: string, word: string) => acc.concat(' ', capitalize(word));

export const capitalizeAll = (value: string) => {
  return (value) ? value.split(' ').reduce(reduceCapitalized, '') : value;
};

export const matches = (haystack: string, needle: string) => {
  const lowHaystack = (haystack) ? haystack.toLowerCase() : '';
  const lowNeedle = (needle) ? needle.toLowerCase() : '';

  return (!lowNeedle || (lowHaystack && lowHaystack.includes(lowNeedle)));
};

export const compare = (a: string, b: string) => a.localeCompare(b);

export const underscore = (value: string) => (value) ? value.replace(' ', '_') : value;

export const valueOf = (value: Object) => (isNullOrUndefined(value)) ? null : value.toString();

export const slugify = (value: string) => {
  const a = 'àáäâãèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/,:;';
  const b = 'aaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------';
  const p = new RegExp(a.split('').join('|'), 'g');
  return value.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^a-zA-Z0-9._-]+/g, '') // Remove all non-word characters except '.','_' and '-'
    .replace(/\-\-+/g, '-') // Replace multiple — with single -
    .replace(/^-+/, ''); // Trim — from start of text .replace(/-+$/, '') // Trim — from end of text
};



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/utils/string.utils.ts